import React from 'react'
import PropTypes from 'prop-types'

import cn from '../../libs/class-name'

import logoIcon from '../../assets/images/logo-icon.svg'

const Section = ({
  id,
  classNames,
  children,
  theme,
  size,
  separator,
  noPadding
}) => (
  <section
    id={id}
    className={cn(
      'Section',
      {
        [`theme-${theme}`]: !!theme,
        [`size-${size}`]: !!size,
        noPadding,
        separator
      },
      classNames
    )}
  >
    {separator && (
      <div className="Section__separator">
        <span className="Section__separatorLogo">
          <img src={logoIcon} alt="" />
        </span>
      </div>
    )}
    {children}
  </section>
)

Section.propTypes = {
  id: PropTypes.string,
  classNames: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf([
    'default',
    'alternative',
    'home',
    'dark',
    'pure-dark',
    'lightning-bitcoin',
    'energy',
    'primary',
    'landingpage',
    'dark-light'
  ]),
  size: PropTypes.oneOf(['default', 's', 'l', 'teaser']),
  separator: PropTypes.bool,
  noPadding: PropTypes.bool
}

export default Section
